module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Novo Email' : 'Editar Email',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "95%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, _vm._l((_vm.gruposForm), function(grupo, index) {
    return _c('details', {
      key: index,
      staticClass: "mb-4 border rounded p-3",
      attrs: {
        "open": grupo.group === 'Geral'
      }
    }, [_c('summary', {
      staticClass: "cursor-pointer font-weight-bold text-lg mb-2"
    }, [_vm._v("\n          " + _vm._s(grupo.group) + "\n        ")]), _vm._v(" "), (grupo.group === 'Tipo de Autenticação') ? [_c('ed-form', {
      attrs: {
        "data": _vm.formData,
        "config": _vm.config,
        "response": _vm.response,
        "itens": grupo.fields
      }
    }), _vm._v(" "), (_vm.formData.tipo_auth === 'oauth2') ? _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "alert alert-info"
    }, [_c('h6', [_c('i', {
      staticClass: "fas fa-info-circle"
    }), _vm._v(" Gmail OAuth2")]), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                Para usar Gmail OAuth2, você precisa apenas autorizar sua conta. \n                As credenciais OAuth2 já estão configuradas no sistema.\n              ")])]), _vm._v(" "), (_vm.formData.id) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('button', {
      staticClass: "btn btn-primary mr-2",
      attrs: {
        "disabled": _vm.config.loading.oauth
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.conectarOAuth2($event)
        }
      }
    }, [(_vm.config.loading.oauth) ? _c('span', {
      staticClass: "spinner-border spinner-border-sm mr-2"
    }) : _vm._e(), _vm._v("\n                🔗 Autorizar Conta Gmail\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-sm ml-2",
      attrs: {
        "disabled": _vm.config.loading.status
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.verificarStatusOAuth2($event)
        }
      }
    }, [(_vm.config.loading.status) ? _c('span', {
      staticClass: "spinner-border spinner-border-sm mr-2"
    }) : _vm._e(), _vm._v("\n                📊 Verificar Status\n              ")])]) : _c('div', {
      staticClass: "alert alert-warning mt-3"
    }, [_c('small', [_c('i', {
      staticClass: "fas fa-save"
    }), _vm._v(" Salve a conta primeiro para poder autorizar o Gmail OAuth2")])]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 text-muted small"
    }, [_c('p', [_vm._v("\n                Ao autorizar, você concorda com o envio automatizado de e-mails relacionados à medicina do trabalho. \n                "), _c('a', {
      staticStyle: {
        "text-decoration": "underline",
        "cursor": "pointer"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.abrirTermoModal($event)
        }
      }
    }, [_vm._v("\n                  Leia o termo de consentimento completo.\n                ")])])]), _vm._v(" "), (_vm.oauthStatus) ? _c('div', {
      staticClass: "mt-3"
    }, [(_vm.oauthStatus.is_fully_configured) ? _c('div', {
      staticClass: "alert alert-success"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "flex-grow-1"
    }, [_c('strong', [_vm._v("✅ Gmail conectado com sucesso!")]), _vm._v(" "), _c('br'), _c('small', [_vm._v("Sua conta está autorizada e funcionando")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.revogarOAuth2
      }
    }, [_vm._v("\n                    Desconectar\n                  ")])])]) : (!_vm.oauthStatus.has_tokens) ? _c('div', {
      staticClass: "alert alert-warning"
    }, [_c('strong', [_vm._v("⚠️ Autorização pendente")]), _vm._v(" "), _c('br'), _c('small', [_vm._v("Clique em \"Autorizar Conta Gmail\" para conectar")])]) : _c('div', {
      staticClass: "alert alert-danger"
    }, [_c('strong', [_vm._v("❌ Erro na autorização")]), _vm._v(" "), _c('br'), _c('small', [_vm._v("Tente autorizar novamente")])])]) : _vm._e()]) : _vm._e()] : (grupo.group === 'Configurações SMTP') ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.formData.tipo_auth || _vm.formData.tipo_auth === 'senha'),
        expression: "!formData.tipo_auth || formData.tipo_auth === 'senha'"
      }]
    }, [(_vm.formData.tipo_auth === 'oauth2') ? _c('div', {
      staticClass: "alert alert-info mb-3"
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    }), _vm._v(" \n              Configurações SMTP não são necessárias para Gmail OAuth2\n            ")]) : _vm._e(), _vm._v(" "), _c('ed-form', {
      attrs: {
        "data": _vm.formData,
        "config": _vm.config,
        "response": _vm.response,
        "itens": grupo.fields
      }
    })], 1), _vm._v(" "), (_vm.formData.tipo_auth === 'oauth2') ? _c('div', {
      staticClass: "alert alert-secondary"
    }, [_c('i', {
      staticClass: "fas fa-shield-alt"
    }), _vm._v(" "), _c('strong', [_vm._v("Gmail OAuth2 selecionado")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("As configurações SMTP não são necessárias. A autenticação será feita diretamente com o Google.")])]) : _vm._e()] : [_c('ed-form', {
      attrs: {
        "data": _vm.formData,
        "config": _vm.config,
        "response": _vm.response,
        "itens": grupo.fields
      }
    })]], 2)
  }), 0)]), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": "Termo de Consentimento",
      "modal": _vm.showTermoModal,
      "width": "600px"
    },
    on: {
      "close": _vm.fecharTermoModal
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto",
      "white-space": "pre-wrap",
      "padding": "1rem",
      "font-size": "0.95rem",
      "line-height": "1.5"
    },
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('p', [_vm._v("\n        Ao conectar sua conta Gmail via OAuth2, você concorda expressamente que este sistema poderá enviar automaticamente mensagens de e-mail relacionadas às atividades profissionais, \n        incluindo comunicações sobre exames médicos, agendamentos e outras informações pertinentes à medicina do trabalho.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        O envio desses e-mails tem como objetivo otimizar a comunicação entre a clínica de medicina do trabalho e os colaboradores, garantindo o cumprimento das normas legais e a segurança dos processos internos.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Todos os dados são tratados com rigorosa confidencialidade, em conformidade com a legislação aplicável de proteção de dados pessoais.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Caso não concorde com este termo, recomendamos que não prossiga com a autorização da conta Gmail via OAuth2.\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34e79c0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/conta-email/editar.vue
// module id = 1453
// module chunks = 45